var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ninety"},[_c('div',{staticClass:"ninety_left"},[_c('p',[_vm._v("八号地豆浆粉上架")]),_c('img',{attrs:{"src":require("../assets/images/豆浆.png"),"alt":"此图片暂时无法显示"}})]),_c('div',{staticClass:"center_content"},[_c('div',{staticClass:"sphere"})]),_c('div',{staticClass:"ninety_right"},[_c('div',{staticClass:"left_bootom"}),_c('p',[_vm._v("2015.12.16")])])])
}]

export { render, staticRenderFns }